// src/components/ReferralHandler.js
import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { captureReferralCodeFromUrl } from '../services/referralStorage';

/**
 * Captures a referral code from `?ref=EB-XXXXXX` on any landing URL and
 * stashes it in localStorage so the eventual signup (email or Google OAuth)
 * can forward it to the backend.
 *
 * Mounted as the catch-all route in App.js — runs whenever someone hits a
 * URL that no other route matched. Always redirects to /auth afterwards.
 */
const ReferralHandler = () => {
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        captureReferralCodeFromUrl(location.search);
        navigate('/auth', { replace: true });
    }, [location, navigate]);

    return null;
};

export default ReferralHandler;
